
import { Injectable, inject } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
/** Service to store and retrieve data from local storage */
export class LocalStorageCacheService {
    private readonly localStorage = inject(StorageMap);


    /* #region Public Methods */
    /** Method used to set data in local storage asynchronously */
    public setItem<T>(key: string, value: T): Observable<boolean> {
        return this.localStorage.set(key, value);
    }

    /** Method used to get data from local storage asynchronously */
    public getItem<T>(key: string): Observable<T | undefined> {
        return this.localStorage.get(key) as Observable<T | undefined>;
    }
    /* #endregion */
}
